const setWindowLocationWithParams = (destinationURL: string) => {
  const queryString = window.location.search;
  const urlParams = window.location.search ? `?${new URLSearchParams(queryString)}` : '';
  window.location.href = `${destinationURL}${urlParams}`;
};

export default setWindowLocationWithParams;
